import { render, staticRenderFns } from "./HeaderSidebarRight.vue?vue&type=template&id=680e1244&scoped=true&"
import script from "./HeaderSidebarRight.vue?vue&type=script&lang=js&"
export * from "./HeaderSidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSidebarRight.vue?vue&type=style&index=0&id=680e1244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e1244",
  null
  
)

export default component.exports